module.exports = __webpack_public_path__ + "static/media/cleaning.68942123.svg";